import { useGridFontSettings } from "../../Business/Service/UISettings/hook/useGridFontSettings";
import { DEFAULT_GRID_FONT_SETTINGS } from "../../libs/ui-settings-manager/UISettingsManager";

export const useGridFontStyle = (): React.CSSProperties => {
    const font = useGridFontSettings();

    const isDefault =
        font.fontSize === DEFAULT_GRID_FONT_SETTINGS.fontSize &&
        font.fontWeight === DEFAULT_GRID_FONT_SETTINGS.fontWeight &&
        font.color === DEFAULT_GRID_FONT_SETTINGS.color;

    if (isDefault) return {};

    return {
        ['--grid-font-size' as any]: `${font.fontSize}px`,
        ['--grid-font-weight' as any]: font.fontWeight,
        ['--grid-font-color' as any]: font.color,
    };
};